export function getDimensions() {
  const width = window.innerWidth || Math.max(document.documentElement.clientWidth, document.body.clientWidth)
  const height = window.innerHeight || Math.max(document.documentElement.clientHeight, document.body.clientHeight)
  return { width, height }
}
